import { IDthContact } from "./clientHttp/models/httpClientModels";
import { ContactFormatEnum } from "./ContactFormatEnum";
import SettingsStore from "../settings/SettingsStore";

/**
 * Restituisce il formato di visualizzazione dei contatti, utilizzando il valore specificato se presente,
 * altrimenti un valore di default.
 * @param contactFormat Il formato di visualizzazione specificato.
 * @returns Il formato di visualizzazione dei contatti.
 */
export function getContactFormatOrDefault(contactFormat?: ContactFormatEnum | null): ContactFormatEnum {
    return contactFormat ?? SettingsStore.getValue("contact_format") ?? ContactFormatEnum.NameSurname;
}

/**
 * Formatta il nome completo di un contatto in base alle preferenze dell'utente.
 * @param name Il nome del contatto.
 * @param surname Il cognome del contatto.
 * @param formatValue Il formato di visualizzazione preferito.
 * @returns Il nome completo formattato.
 */
export function formatDisplayName(name: string, surname: string, formatValue: ContactFormatEnum | null): string {
    const format = getContactFormatOrDefault(formatValue);

    // Costruisci il nome in base al formato selezionato
    return format === ContactFormatEnum.SurnameName
        ? `${surname} ${name}`.trim()
        : `${name} ${surname}`.trim();
}

/**
 * Restituisce il nome del contatto formattato in base alle preferenze dell'utente,
 * o il nome di default se il contatto non è definito.
 * @param contact Il contatto da formattare.
 * @param format Il formato di visualizzazione preferito.
 * @returns Il nome del contatto formattato.
 */
export function getContactNameFormat(contact: IDthContact | undefined, format: ContactFormatEnum | null): string {
    if (!contact) return "";

    return formatDisplayName(contact.firstName, contact.lastName, format);
}
